"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, urls, id, values, Flash, $timeout, permissions, $uibModal) {
  $scope.confirmDelete = function(flag) {
    $scope.showConfirmDelete = flag;
  };
  $scope.delete = function(id) {
    $scope.showConfirmDelete = false;
    $http.delete('/api/collection/' + id + '.json').then(function(response) {
      window.location = '/collection?page=1';
    }, function(response) {
      var message = '<strong>Fehler beim löschen!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
  };
  $scope.hasPermission = function(permission) {
    if (typeof $scope.permissions == 'undefined' || $scope.permissions == null) {
      return false;
    }
    var index = $scope.permissions.indexOf(permission);
    if (index > -1) {
      return true;
    }
    return false;
  };
  $scope.hasFlag = function(flags, flag) {
    var index = flags.indexOf(flag);
    if (index > -1) {
      return true;
    }
    return false;
  };
  $scope.$watch('title', function() {
    if (hlp.isSet($scope.title)) {
      window.document.title = $scope.title + " - Sammlung";
    }
  }, true);
  $scope.copyCollection = function(id) {
    var scope = $scope;
    var modalInstance = $uibModal.open({
      templateUrl: 'collection/templates/copyModal.ng.html',
      controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
        var init = function() {
          $scope.name = 'Kopie von ' + scope.collection.name;
          $scope.description = scope.collection.beschreibung;
        }();
        $scope.confirmCopy = function() {
          var params = {
            name: $scope.name,
            description: $scope.description
          };
          $http.post('/api/collection.json?copyFrom=' + id, angular.toJson(params)).then(function(response) {
            window.location = '/collection/edit/' + response.data._id.$oid;
          }, function(response) {
            var message = '<strong>Fehler beim speichern!</strong>.';
            Flash.create('danger', message, 0, {}, true);
          });
        };
      }]
    });
  };
  var init = function() {
    $scope.urls = urls;
    $scope.id = id;
    $scope.permissions = permissions;
    $scope.tempCollection = [];
    if (values != "") {
      $scope.collection = JSON.parse(values);
      $scope.title = $scope.collection.name;
    } else {
      $scope.collection = {};
      $scope.title = "";
    }
    $scope.flags = [{
      "id": 'PRIVATE',
      "label": 'Privat'
    }, {
      "id": 'PUBLIC',
      "label": 'Öffentlich'
    }];
  }();
};
module.exports = controller;
